const badgeResetTimers = {};
/** Start: card-product.js - Unified product card handling (page 1 + infinite scroll) - Pratham */
(function () {
  if (window.__cardProductInit) return;
  window.__cardProductInit = true;

  /** Utility: get quantity from cartVariantMap */
  function getQty(variantId) {
    try {
      if (window.cartVariantMap && typeof window.cartVariantMap[variantId] !== "undefined") {
        return Number(window.cartVariantMap[variantId]) || 0;
      }
    } catch (e) {}
    return 0;
  }

/** Update in-cart badges (always show “You have … in cart”) */
function updateBadges(scope) {
  const root = scope || document;
  const badges = root.querySelectorAll(".in-cart-badge");

  badges.forEach((el) => {
    const productId = el.getAttribute("data-product-id");
    if (!productId) return;

    const variantList = el.querySelector(".in-cart-variants");
    if (variantList) variantList.innerHTML = "";

    let lines = [];
    let hasQty = false;

    // Find wrapper and parse variantData for proper order
    const wrapper = document.querySelector(`.product-card-wrapper [data-product-id="${productId}"]`)?.closest(".product-card-wrapper");
    let variantData = [];
    try {
      variantData = wrapper ? JSON.parse(wrapper.dataset.variants || "[]") : [];
    } catch (err) {
      console.warn("⚠️ Could not parse dataset.variants for product", productId, err);
    }

    // Loop in variantData order, not random DOM order
    variantData.forEach((variant) => {
      const vid = String(variant.id);
      const qty = getQty(vid);

      if (qty > 0) {
        hasQty = true;
     let title = variant.title || "";

// Strip anything inside parentheses → e.g. "Shipper (20 Bag)" → "Shipper"
title = title.replace(/\s*\(.*?\)/, "").trim();

// Also clean "Variant" if Shopify left it in
title = title.replace(/variant/gi, "").trim();

lines.push(`${qty} × ${title}`);
console.log("[updateBadges] VID=", vid, "qty=", qty, "title=", title);
      }
    });

    if (variantList && lines.length) {
      let text = "";
      if (lines.length === 1) {
        text = `You have ${lines[0]} in cart`;
      } else if (lines.length === 2) {
        text = `You have ${lines[0]} and ${lines[1]} in cart`;
      } else {
        const last = lines.pop();
        text = `You have ${lines.join(", ")}, and ${last} in cart`;
      }
      console.log("[updateBadges] productId=", productId, "→", text);
      variantList.textContent = text;
    }

    if (hasQty && lines.length > 0) {
  el.style.display = "block";
  el.hidden = false;
  el.setAttribute("aria-hidden", "false");
} else {
  el.style.display = "none";
  el.hidden = true;
  el.setAttribute("aria-hidden", "true");
}

  });
}



  /** Sync cart quantities */
  function syncCartQuantities() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        window.cartVariantMap = {};
        cart.items.forEach((item) => {
          window.cartVariantMap[item.variant_id] = item.quantity;
        });
        document.dispatchEvent(new CustomEvent("variantStockMap:updated"));
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncCartQuantities);
  } else {
    syncCartQuantities();
  }

  document.addEventListener("cart:updated", syncCartQuantities);
  document.addEventListener("cart-request:complete", syncCartQuantities);
  document.addEventListener("variantStockMap:updated", (e) => {
    updateBadges(e && e.detail ? e.detail.scope : null);
  });
  



/** Core: init product cards */
  function initProductCards(scope = document) {
    // Add 'index' to the loop and wrap the logic in a staggered setTimeout
    scope.querySelectorAll("product-form .product-form").forEach((form, index) => {
      setTimeout(() => {
        if (form.dataset.jsBound === "true") return;
        form.dataset.jsBound = "true";

      const idInput = form.querySelector("input[name='id']");
      const wrapper = form.closest(".product-card-wrapper");
      if (!wrapper) return;

      let variantData = [];
      try {
        variantData = JSON.parse(wrapper.dataset.variants || "[]");
      } catch (err) {
        console.warn("⚠️ Could not parse dataset.variants:", err);
      }

      // Support both product-page style radios ("option1") and card radios ("id")
const radios = form.querySelectorAll("input[type='radio'][name^='option'], input[type='radio'][name='id']");

      const select = form.querySelector("select[name='id']");

      /** Update UI for selected variant */
      function updateUI(variant) {
        if (!variant) return;

        idInput.value = variant.id;
        idInput.dataset.variantTitle = variant.title;

        const priceWrapper = wrapper.querySelector("[data-price-wrapper]");
        const block = wrapper.querySelector(
          `.variant-prices .variant-price-block[data-variant-id="${variant.id}"]`
        );
        if (priceWrapper && block) {
          const priceEl = block.querySelector(".price");
          if (priceEl) {
            priceWrapper.innerHTML = priceEl.outerHTML;
          }
        }

const inventoryPill = wrapper.querySelector(".product__inventory");
if (inventoryPill) {
  const stock = window.variantStockMap?.[variant.id] || 0;

  // Reset classes
  inventoryPill.className = "product__inventory product__inventory--pill mb-05 no-js-hidden";
  inventoryPill.setAttribute("role", "status");

  if (variant.available && stock > 0) {
    if (stock <= 10) {
      // Low stock → orange pill
      inventoryPill.classList.add("product-inventory--low");
      inventoryPill.innerHTML = `
        <svg width="20" height="20" aria-hidden="true" class="product-inventory--low">
        <circle class="bg-circle" cx="10" cy="10" r="10" fill="rgba(181,129,62, 0.3)"></circle>
        <circle cx="10" cy="10" r="6" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgba(181,129,62, 0.7)"></circle>
        </svg>
        Low stock! Only ${stock} left
      `;
    } else {
      // In stock → green pill (styled same as theme "normal")
      inventoryPill.classList.add("product-inventory--normal");
      inventoryPill.innerHTML = `
      <svg width="20" height="20" aria-hidden="true" class="product-inventory--normal">
      <circle class="bg-circle" cx="10" cy="10" r="10" fill="rgba(85,175,16, 0.3)"></circle>
      <circle cx="10" cy="10" r="6" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgba(85,175,16, 0.7)"></circle>
      </svg>
      ${stock} in stock
      `;
    }
  } else if (variant.available && variant.inventory_policy === "continue") {
    inventoryPill.classList.add("product-inventory--backorder");
    inventoryPill.innerHTML = `
      <svg width="20" height="20" aria-hidden="true" class="product-inventory--backorder"></svg>
      Available on backorder
    `;
  } else {
    inventoryPill.classList.add("product-inventory--out");
    inventoryPill.innerHTML = `
      <svg width="20" height="20" aria-hidden="true" class="product-inventory--out">
      <circle class="bg-circle" cx="10" cy="10" r="10" fill="rgba(91,91, 91, 0.3)"></circle>
      <circle cx="10" cy="10" r="6" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgba(91,91, 91, 0.7)"></circle>
      </svg>
      Back Soon
    `;
  }

  console.log("[InventoryPill] Variant", variant.id, "→ stock:", stock);
}



// 👇 Add this line to update SKU dynamically
  updateSku(wrapper, variant.id);   // 👈


// Always re-sync clamp and badges after variant switch
applyClamp(wrapper, variant);

// Force in-cart refresh using latest cartVariantMap
updateBadges(wrapper);

// Force sync so cartVariantMap doesn’t get “forgotten”
document.dispatchEvent(new Event("variantStockMap:updated"));

      }

      /** Clamp quantity input */
      function applyClamp(wrapper, variant) {
        const qtyInput = wrapper.querySelector("input[name='quantity']");
        if (!qtyInput) return;

        const enforceClamp = () => {
          const maxStock = Number(window.variantStockMap?.[variant.id] || 0);
          const inCart = getQty(variant.id);
          const maxAllowed = Math.max(maxStock - inCart, 0);

          if (maxStock > 0) {
            qtyInput.max = maxAllowed;
            if (!qtyInput.value || Number(qtyInput.value) < 1) qtyInput.value = 1;
            if (Number(qtyInput.value) > maxAllowed) qtyInput.value = maxAllowed;
          } else {
            qtyInput.removeAttribute("max");
            qtyInput.value = 1;
          }
        };

        enforceClamp();

// Remove old listeners before re-binding
["input", "change", "blur"].forEach((evt) => {
  qtyInput.removeEventListener(evt, qtyInput._clampHandler || (() => {}));
});

// Save the current enforceClamp as handler for this variant
qtyInput._clampHandler = enforceClamp;

// Re-bind with the correct variant-specific clamp
["input", "change", "blur"].forEach((evt) => {
  qtyInput.addEventListener(evt, qtyInput._clampHandler);
});

      }

      /** Submit guard */
      form.addEventListener("submit", (e) => {
        const variantId = idInput.value;
        const qtyInput = form.querySelector("input[name='quantity']");
        if (!qtyInput) return;

        const val = Number(qtyInput.value) || 1;
        const maxStock = Number(window.variantStockMap?.[variantId] || 0);
        const inCart = getQty(variantId);
        const maxAllowed = Math.max(maxStock - inCart, 0);

        if (maxStock > 0 && inCart >= maxStock) {
          e.preventDefault();
          e.stopPropagation();
          showTempBadge(wrapper, `All available stock of ${idInput.dataset.variantTitle || "this variant"} is in your cart`);
          console.log("[submitGuard] Blocked → Already at max", variantId, "inCart=", inCart, "maxStock=", maxStock);
          console.log("[submitGuard] Blocked → Tried to exceed max", variantId, "val=", val, "maxAllowed=", maxAllowed);
          return false;
        }

        if (maxStock > 0 && val > maxAllowed) {
          e.preventDefault();
          e.stopPropagation();
          qtyInput.value = maxAllowed > 0 ? maxAllowed : 1;
          showTempBadge(wrapper, `Only ${maxAllowed} left (already ${inCart} in your cart)`);
          console.log("[submitGuard] Blocked → Already at max", variantId, "inCart=", inCart, "maxStock=", maxStock);
          console.log("[submitGuard] Blocked → Tried to exceed max", variantId, "val=", val, "maxAllowed=", maxAllowed);
          return false;
        }
      });

      /** Show a temporary overwrite, then revert */
      function showTempBadge(wrapper, message) {
        const badge = wrapper.querySelector(".in-cart-variants");
        if (!badge) return;

        const badgeWrap = wrapper.querySelector(".in-cart-badge");
        const productId = badgeWrap?.getAttribute("data-product-id");
        if (!productId) return;

        badge.textContent = message;
        badgeWrap.hidden = false;

        if (badgeResetTimers[productId]) {
          clearTimeout(badgeResetTimers[productId]);
        }

        badgeResetTimers[productId] = setTimeout(() => {
          updateBadges(wrapper); // revert to standard message
          delete badgeResetTimers[productId];
        }, 4000);
      }

  radios.forEach((radio) => {
  radio.addEventListener("change", () => {
    let match;
    if (radio.name === "id") {
      // Direct variant.id radios (collection cards)
      match = variantData.find((v) => String(v.id) === String(radio.value));
    } else {
      // Option radios (product page style)
      match = variantData.find((v) =>
        v.options.every((opt, i) => opt === getSelectedOptions()[i])
      );
    }
    if (match) updateUI(match);
  });
});


      if (select) {
        select.addEventListener("change", () => {
          const match = variantData.find((v) => String(v.id) === String(select.value));
          if (match) updateUI(match);
        });
      }

     // Ensure first visible available variant is picked if default is hidden
let initialVariant = variantData.find((v) => v.id == idInput.value);
      if (!initialVariant || !initialVariant.available) {
        initialVariant = variantData.find((v) => v.available);
      }
      if (initialVariant) updateUI(initialVariant);

      }, index * 35); // Staggers each card's load by 35 milliseconds
    });
  }

  function getSelectedOptions() {
    const opts = [];
    document.querySelectorAll("[data-option-index]").forEach((el) => {
      const checked = el.querySelector("input:checked");
      if (checked) opts[el.dataset.optionIndex] = checked.value;
    });
    return opts;
  }

 // OPTIMIZED: Delay initialization until the main thread is idle to reduce Total Blocking Time
  const runInit = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => initProductCards(document), { timeout: 1000 });
    } else {
      setTimeout(() => initProductCards(document), 100);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

 // Handle infinite scroll loads: merge stock first, then init cards
document.addEventListener("ajaxify:loaded", function(e) {
  if (!window.variantStockMap) window.variantStockMap = {};

  // Merge stock first
  const newStocks = document.querySelectorAll(".variant-stock-entry");
  newStocks.forEach(entry => {
    const id = entry.dataset.variantId;
    const stock = parseInt(entry.dataset.stock, 10) || 0;
    if (!(id in window.variantStockMap)) {
  window.variantStockMap[id] = stock;
  console.log("[StockMap Merge] variant", id, "→", stock);
} else {
  console.log("[StockMap Merge] skipped duplicate for variant", id, "stock", stock);
}

  });

  // Then init cards
  let scope = document;
  if (e && e.detail && e.detail.nodes) {
    e.detail.nodes.forEach((node) => {
      initProductCards(node);
      updateBadges(node);
    });
  } else {
    initProductCards(scope);
    updateBadges(scope);
  }

  // Trigger refresh
  document.dispatchEvent(new Event("variantStockMap:updated"));
});

})();
/** End: card-product.js - Pratham */


/** Update SKU dynamically */
function updateSku(root, variantId) {
  const skuBlock = root.querySelector(`.variant-sku-block[data-variant-id="${variantId}"]`);
  const skuContainer = root.querySelector(".card-sku .sku-value");
  if (skuBlock && skuContainer) {
    const sku = skuBlock.getAttribute("data-sku");
    skuContainer.textContent = sku || "";
  }
}